import styled from "styled-components";
import {isSuperUser, Person, Profile, StyledBaseProps} from "@betrue/shared/interfaces";
import {FormControlLabel, Grid, Switch} from "@material-ui/core";
import {PublicProfileConsentProps} from "./public-profile-consent";
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import * as React from "react";
import {PublicProfileCardView, PublicProfileCardViewHeight} from "../public-profiles/pulic-profile-card.view";
import {AdminZone} from "../admin-zone/admin-zone";

export interface PublicProfileConsentViewProps extends StyledBaseProps, PublicProfileConsentProps {
  profile: Profile
  person: Person
  onToogle: (consent: string) => void
  principal: Person
  onAdminConsent: (consent: boolean) => void
}

export const PublicProfileConsentView = styled((props: PublicProfileConsentViewProps) => (
  <span className={props.className}>
    <Grid container direction={'column'}
          alignItems={'center'}
          alignContent={"center"}
          spacing={2}>
      <Grid item>

        <ToggleButtonGroup
          className={'bt-toogle'}
          value={props.profile.publicConsent ? 'yes' : 'no'}
          defaultValue={props.profile.publicConsent ? 'yes' : 'no'}
          onChange={(e, v) => {
            props.onToogle(v)
          }}
          exclusive>
          <ToggleButton value={'yes'}>{props.acceptLabel ? props.acceptLabel : 'Oui' +
            ' j\'accepte'}</ToggleButton>
          <ToggleButton color={'secondary'}
                        value={'no'}>{props.refuseLabel ? props.refuseLabel : 'Non je refuse'}</ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid item>
        <AdminZone subject={props.person} principal={props.principal}>
          <FormControlLabel
           control={
             <Switch
               defaultChecked={props.profile.internalConsent}
               onChange={(e) => props.onAdminConsent(e.target.checked)}/>
           }
           color={'secondary'}
           label="(ADMINs) Publier le profil?"
         />
        </AdminZone>
      </Grid>
 </Grid>
     <div className={'bt-profile-consent'}>
        {!props.profile.publicConsent ? <div className={'bt-no-consent'}/> : ''}
       <PublicProfileCardView profile={props.profile} person={props.person}/>
      </div>
  </span>
))`
  & {
    .bt-toogle {
      button {
        :hover {
          background-color: ${props => props.theme.colors.successBackground};

        }
      }

      .Mui-selected {
        border-color: ${props => props.theme.colors.success};
        color: ${props => props.theme.colors.success};
        background-color: ${props => props.theme.colors.successBackground};

      }
    }

    .bt-profile-consent {
      padding-top: 20px;
      display: block;
      position: relative;
      min-width: 100%;
      margin-left: auto;
      margin-right: auto;

      .bt-no-consent {
        z-index: 10;
        border-radius: 5px;
        background-color: ${props => props.theme.colors.disabledTransparent};
        width: 100%;
        height: ${PublicProfileCardViewHeight};
        position: absolute;

      }
    }

    .bt-consent-accept {
      color: ${props => props.theme.colors.success};
    }


    .bt-consent-refuse {
      color: ${props => props.theme.colors.warning};
    }
  }

`
